<template>
  <div>
    <v-row no-gutters>
      <v-col :cols="12" class="px-1">
        <dd-custom-button
          :rounded="true"
          :minWidth="60"
          :small="true"
          tooltipText="給油実績データを取込します。"
          :enableToolTip="helpUseFlg"
          @click="onOpenCloseClick"
          :tooltipBottom="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="15.828" height="15.828" viewBox="0 0 15.828 15.828">
            <path id="import" d="M15.828,2.473V13.355a2.476,2.476,0,0,1-2.473,2.473H2.473A2.476,2.476,0,0,1,0,13.355V11.809a.742.742,0,0,1,1.484,0v1.546a.99.99,0,0,0,.989.989H13.355a.99.99,0,0,0,.989-.989V2.473a.99.99,0,0,0-.989-.989H2.473a.99.99,0,0,0-.989.989V4.019A.742.742,0,1,1,0,4.019V2.473A2.476,2.476,0,0,1,2.473,0H13.355a2.476,2.476,0,0,1,2.473,2.473ZM0,7.914a.742.742,0,0,0,.742.742H7.077L5.55,10.183A.742.742,0,1,0,6.6,11.233L9.393,8.439a.742.742,0,0,0,0-1.049L6.6,4.6A.742.742,0,0,0,5.55,5.645L7.077,7.172H.742A.742.742,0,0,0,0,7.914Z" fill="#fff"/>
          </svg>
          給油実績データ取込はこちら
        </dd-custom-button>
      </v-col>
    </v-row>

    <v-dialog v-model="showDialog" width="60vw" style="z-index:550" persistent no-click-animation>
      <v-card min-height="75%" min-width="95%">
        <v-toolbar color="#2F75B5" dark dense>
          <v-spacer></v-spacer>
          <v-toolbar-title>給油実績データ取込</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="onOpenCloseClick" text><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <div v-if="dispSearchMode">
          <v-card-text class="px-1">
            <v-container class="ma-0 pa-2" fluid>
              <v-row no-gutters>
                <v-col :cols="12">
                  <v-row no-gutters justify="start">
                    <dd-sub-header>
                      <span>以下の条件で給油実績データを取り込む</span>
                    </dd-sub-header>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <span class="ml-1 view-description">取込条件の入力と給油実績ファイルを選択して、[取込]を押下してください。<br/>取込用テンプレートファイルを出力する場合は[取込用テンプレート出力]ボタンを押下してください。</span>
              </v-row>
              <v-row no-gutters>
                <v-col :cols="3" class="px-1">
                  <dd-code-text-box
                    label="仕入先コード/名称"
                    v-model="conditions.importShiiresakiId"
                    ref="importShiiresakiId"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Free"
                    titleText="取引先検索"
                    :headerList="mstTorihikisakiHeaders"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    returnValueName="id"
                    :required="true"
                    :searchColumns="['torihikisakiCd', 'torihikisakiNm', 'torihikisakiNmKana']"
                    :itemList="filteredShiiresakiList"
                    tooltipText="必須項目です。<br>給油元を入力しましょう。"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </v-col>
                <v-col :cols="3" class="px-1">
                  <dd-drop-down
                    label="レイアウト選択"
                    v-model="conditions.importFileKbn"
                    ref="importFileKbn"
                    placeholder="選択してください"
                    tooltipText="必須項目です。<br>取込ファイルの種類を選択しましょう"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                    :required="true"
                    :items="filteredNenryoTorikomiLayoutKbnList"/>
                </v-col>
                <v-col :cols="6" class="px-1">
                  <dd-file-input
                    label="ファイル選択"
                    v-model="conditions.file"
                    @change="storeFileInfo"
                    :required="true"
                    ref="file"
                    truncate-length="100"/>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <dd-custom-button class="mx-5" color="#2F75B5" :minWidth="100" @click="onOpenCloseClick">閉じる</dd-custom-button >
            <v-spacer></v-spacer>
            <dd-custom-button class="mx-5" color="#2F75B5" :minWidth="100" :loading="isTemplateDownloader"  @click="onTorikomiTemplateButtonClick">
              <template v-slot:loader>
                <span>出力中...</span>
              </template>
              取込用テンプレート出力
            </dd-custom-button>
            <a id="templateDownload" href="#" style="display:none;">ダウンロード</a>
            <dd-custom-button class="mx-5" color="#2F75B5" :minWidth="100" @click="onFileImportButtonClick">
              取込
            </dd-custom-button>
          </v-card-actions>
        </div>
        <div v-else>
          <v-card-text class="px-1">
            <v-row no-gutters>
              <v-col :cols="12">
                <v-row no-gutters justify="start">
                  <dd-sub-header>
                    <span>以下の給油実績データを取り込みました。</span>
                  </dd-sub-header>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <span class="ml-1 view-description">取込み結果の確認を終える場合は、[閉じる]を押下してください。<br/>続けて、他のファイルも取込む場合は[さらに別ファイルも取込む]ボタンを押下してください。</span>
            </v-row>
            <v-row no-gutters>
              <v-col :cols="4">
                <span class="search-number">{{ rowCount }}</span>
                <span style="display:inline-block;width:100px;vertical-align:bottom">件 の取込結果</span>
              </v-col>
              <v-col :cols="4" class="mt-2">
                <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
              </v-col>
              <v-col :cols="4" class="px-1">
                <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
              </v-col>
            </v-row>

            <hr class="section-line mb-2">

            <v-row no-gutters justify="end">
              <v-col :cols="4"/>
              <v-col :cols="8">
                <dd-select-items-per-page
                  ref="pagination1"
                  :itemsPerPage.sync="itemsPerPage"
                  :currentPage.sync="page"
                  :items="filteredRows"
                  @changeItemsPerPage="changeItemsPerPage"
                  @changePage="changePage"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col :cols="12" class="px-1">
                <v-data-table
                  item-key="rowNo"
                  :headers="dispHeader"
                  :items="filteredRows"
                  :search="searchText"
                  :custom-filter="filtering"
                  :itemsPerPage="itemsPerPage"
                  :page.sync="page"
                  no-data-text="対象データはありません"
                  fixed-header
                  class="fixed-column-table"
                  hide-default-footer
                  locale="ja-jp"
                  dense
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <dd-custom-button class="mx-5" color="#2F75B5" :minWidth="100" @click="onOpenCloseClick">閉じる</dd-custom-button >
            <v-spacer></v-spacer>
            <dd-custom-button class="mx-5" color="#2F75B5" :minWidth="100" @click="onDispSearchModeClick">さらに別ファイルも取込む</dd-custom-button >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import modals from '@/ddv2.library/modals'
import message from '@/ddv2.library/messages'

import DdCustomButton from '@/components/DdCustomButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdFileInput from '@/components/DdFileInput'
import DdDropDown from '@/components/DdDropDown'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'

export default {
  name: 'DdKyuyuFileImportButton',
  mixins: [flowMixin],
  props: {
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DdCustomButton,
    DdSubHeader,
    DdCodeTextBox,
    DdFileInput,
    DdDropDown,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage
  },
  data: () => ({
    showDialog: false,
    conditions: {},
    isTemplateDownloader: false,
    dispSearchMode: true,
    // ヘッダー定義
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    // 一覧制御用
    itemsPerPage: 10,
    page: 1
  }),
  created () {
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      kubunList: 'DDMasters/msysKubun'
    }),
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 仕入先フィルター
    filteredShiiresakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.shiiresakiFlg === true
      })
    },
    // 給油実績データ取込レイアウト区分フィルター
    filteredNenryoTorikomiLayoutKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF108')
    },
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem, index) => {
        elem.rowNo = index + 1
        elem.hasseiYmd = elem.hasseiYmd ? filter.dateFormatter(elem.hasseiYmd) : ''
        elem.hasseiHms = elem.hasseiHms ? (elem.hasseiHms).slice(0, 5) : ''
        elem.sharyoShozokuEigyoshoDisp = elem.sharyoShozokuEigyoshoCd ? elem.sharyoShozokuEigyoshoCd + ' : ' + elem.sharyoShozokuEigyoshoNm : ''
        elem.suryo = elem.suryo ? filter.numericFormatter(elem.suryo) : ''
        elem.keihiTanka = elem.keihiTanka ? filter.numericFormatter(elem.keihiTanka) : ''
        elem.keihiKingaku = elem.keihiKingaku ? filter.numericFormatter(elem.keihiKingaku) : ''
        elem.odoMater = elem.odoMater ? filter.numericFormatter(elem.odoMater) : ''
        elem.memo = elem.editFlg === true ? '変更中' : '　　　'
        elem.hasseiYmdDisp = elem.hasseiYmd ? filter.dateFormatter(elem.hasseiYmd) : ''
        elem.hasseiHmsDisp = elem.hasseiHms ? (elem.hasseiHms).slice(0, 5) : ''
        elem.torikomiShiiresakiDisp = elem.torihikisakiCd ? elem.torihikisakiCd + ' : ' + elem.torihikisakiNm : elem.torikomiShiiresakiCd
        elem.torikomiSharyoDisp = elem.sharyoNo ? elem.sharyoNo + ' : ' + elem.mstSharyoNm : elem.torikomiSharyoNo
        elem.suryoDisp = elem.suryo ? filter.numericFormatter(elem.suryo) : ''
        elem.keihiTankaDisp = elem.keihiTanka ? filter.numericFormatter(elem.keihiTanka) : ''
        elem.odoMaterDisp = elem.odoMater ? filter.numericFormatter(elem.odoMater) : ''
        elem.sagyoJisshiBashoDisp = elem.sagyoJisshiBasho ? elem.sagyoJisshiBasho : ''
        elem.kessaiCardNumberDisp = elem.kessaiCardNumber ? elem.kessaiCardNumber : ''
        return elem
      })
    },
    dispHeader () {
      const header = [
        { text: 'ID', value: 'id', align: ' d-none' },
        { text: '行', value: 'rowNo', align: 'center', sortable: false, width: '80px' },
        { text: '発生年月日', value: 'hasseiYmdDisp', width: '175px' },
        { text: '発生時刻', value: 'hasseiHmsDisp', width: '125px' },
        { text: '仕入先', value: 'torikomiShiiresakiDisp', width: '270px' },
        { text: '営業所', value: 'sharyoShozokuEigyoshoDisp', width: '270px' },
        { text: '車種', value: 'shashuSbtNm', width: '85px' },
        { text: '車両番号/自動車表示名', value: 'torikomiSharyoDisp', width: '270px' },
        { text: '燃料区分', value: 'nenryoShuruiKbnNm', width: '155px' },
        { text: 'エラーメッセージ', value: 'errMessage' },
        { text: '数量', value: 'suryoDisp', align: 'end' },
        { text: '単価', value: 'keihiTankaDisp', align: 'end' },
        { text: '金額', value: 'keihiKingaku', align: 'end' },
        { text: '給油時オド', value: 'odoMaterDisp', align: 'end' },
        { text: '給油SS', value: 'sagyoJisshiBashoDisp', width: '300px' },
        { text: 'カードNo', value: 'kessaiCardNumberDisp', width: '200px' },
        { text: '車両経費No', value: 'sharyoKeihiNo' }
      ]
      return header
    }
  },
  methods: {
    // --------------------------------------------------------------------------------
    // ダイアログ開閉ボタン押下
    // --------------------------------------------------------------------------------
    onOpenCloseClick: function (e) {
      this.showDialog = !this.showDialog
      this.initBindVariables()
    },
    storeFileInfo: function (p) {
      console.log('file selected', p)
      if (p === undefined || p === null) {
        this.conditions.uploadFileName = ''
        this.conditions.uploadFileData = ''
        return
      }
      this.clearInvalidMessage(this.$refs)
      this.Effects.loadStart()
      this.conditions.uploadFileName = p.name

      const fr = new FileReader()
      fr.readAsDataURL(p)
      fr.addEventListener('load', () => {
        this.conditions.uploadFileData = fr.result
      })
      this.Effects.loadComplete()
      console.log('file selected e')
    },
    onTorikomiTemplateButtonClick: function (e) {
      this.isTemplateDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2fued0010/NenryoTorikomiTemplateOutput', this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('templateDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '給油実績取込テンプレート_' + ts + '.xlsx'
          elem.click()
          modals.showToastMessage('COMI0005', null, 500, null, 'info')
          this.isTemplateDownloader = false
        })
    },
    onFileImportButtonClick: function (e) {
      let errorCount = 0
      if ((['', null, undefined]).includes(this.conditions.importShiiresakiId)) {
        this.$refs.importShiiresakiId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        errorCount++
      }
      if ((['', null, undefined]).includes(this.conditions.importFileKbn)) {
        this.$refs.importFileKbn[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        errorCount++
      }
      if ((['', null, undefined]).includes(this.conditions.uploadFileData)) {
        this.$refs.file[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        errorCount++
      }
      if (errorCount > 0) { return }
      const importConditions = {
        importShiiresakiId: this.conditions.importShiiresakiId,
        importFileKbn: this.conditions.importFileKbn,
        uploadFileName: this.conditions.uploadFileName,
        uploadFileData: this.conditions.uploadFileData
      }
      this.Effects.loadStart()
      this.HttpClient.post('/api/v1/vwCD2fued0010/NenryoFileImport', importConditions)
        .then((data) => {
          if (data.isValid) {
            console.log('retdata', data)
            modals.showToastMessage(data.summaryMessage.messageCd, null, 500, null, 'info')
            this.rows = data.payload.resultList
            this.dispSearchMode = false
            this.Effects.loadComplete()
            // this.transition(0, { id: data.payload, edit: 1 })
          } else {
            modals.showToastMessage(data.summaryMessage.messageCd, null, 500, null, 'error')
            this.Effects.loadComplete()
          }
        }).catch((e) => {
          console.log('error', e)
          modals.showToast(e.message, null, 500, null, 'error')
          this.Effects.loadComplete()
        })
    },
    onDispSearchModeClick: function () {
      const self = this
      self.conditions.file = null
      self.conditions.uploadFileName = ''
      self.conditions.uploadFileData = ''
      self.dispSearchMode = true
    },
    initBindVariables: function (p) {
      const self = this
      const initConditions = {
        importShiiresakiId: null,
        importFileKbn: '01',
        uploadFileName: '',
        uploadFileData: ''
      }
      self.conditions = Object.assign({}, initConditions)
      self.dispSearchMode = true
      // InvalidMessage初期化
      self.clearInvalidMessage(self.$refs)
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      // this.$set(this, 'itemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
      })
    }
  }
}
</script>
<style scoped>
</style>
